import { useEffect, useState } from 'react';

import { FeatureFlags } from 'V2/Utilities/FeatureFlags';
import { StateCodeType } from 'V2/Types';

import { FlagsByState, StateFlagsInitializerProps } from './types';

const FLAGS_BY_STATE: FlagsByState = {
  FL: {
    coverages_requirements_note: false,
    fee_strategy_quote_loader: true,
    quote_progress_indicator: true,
  },
};

export const StateFlagsInitializer: React.FC<StateFlagsInitializerProps> = ({
  state,
  children,
}) => {
  // We don't actually need to track "ready" state here since
  // we render children immediately after setting flags.
  // However, we use a state update to ensure a re-render
  // after flags have been set.
  const [, setReady] = useState(false);

  useEffect(() => {
    try {
      const stateFlags = FLAGS_BY_STATE[state as StateCodeType];

      if (state && stateFlags) {
        FeatureFlags.override(stateFlags);
      }
    } finally {
      // Don't block rendering of children if flag initialization fails.
      // On error, we simply render with default flags.
      setReady(true);
    }
  }, [state]);

  return <>{children}</>;
};
